import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';

// forwardRef so a ref on a card (e.g. a table container) reaches the DOM node
export const Card = forwardRef(function Card({ as: Tag = 'div', className, children, ...props }, ref) {
    return (
        <Tag
            ref={ref}
            className={cn(
                'rounded-xl border border-slate-200/80 bg-white shadow-card dark:border-slate-800 dark:bg-slate-900 dark:shadow-none',
                className
            )}
            {...props}
        >
            {children}
        </Tag>
    );
});

export function CardHeader({ title, description, icon: Icon, iconClassName, action, className }) {
    return (
        <div
            className={cn(
                'flex items-start justify-between gap-4 border-b border-slate-100 px-5 py-4 sm:px-6 dark:border-slate-800',
                className
            )}
        >
            <div className="flex min-w-0 items-center gap-3">
                {Icon && (
                    <span className={cn('flex h-10 w-10 shrink-0 items-center justify-center rounded-lg', iconClassName)}>
                        <Icon className="h-5 w-5" aria-hidden="true" />
                    </span>
                )}
                <div className="min-w-0">
                    <h3 className="truncate text-base font-semibold text-slate-900 dark:text-slate-100">{title}</h3>
                    {description && (
                        <p className="mt-0.5 truncate text-sm text-slate-500 dark:text-slate-400">{description}</p>
                    )}
                </div>
            </div>
            {action}
        </div>
    );
}
